'use client';

import React, { createContext, useContext } from 'react';
import type { DisplayTextConfig } from '@/lib/display-text';
import type { TopNavItem } from '@/lib/navigation-config';
import type { ShopInfoConfig } from '@/lib/shop-info-config';
import type { HomepageConfig } from '@/lib/homepage-config';
import type { CatalogMenuItem } from '@/lib/catalog-menu';

export type SiteConfigContextValue = {
  navigation: {
    topNav: TopNavItem[];
    quickSearch: string[];
    megaMenu: CatalogMenuItem[];
    displayTextConfig: DisplayTextConfig;
    shopInfoConfig: ShopInfoConfig;
  };
  footer: {
    footerSection: HomepageConfig['footerSection'];
    footerVisible: boolean;
  };
};

const SiteConfigContext = createContext<SiteConfigContextValue | null>(null);

export function SiteConfigProvider({
  value,
  children,
}: {
  value: SiteConfigContextValue;
  children: React.ReactNode;
}) {
  return <SiteConfigContext.Provider value={value}>{children}</SiteConfigContext.Provider>;
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
